import { AbstractTrackingService } from "./abstract-tracking-service";
import { sprig } from "@sprig-technologies/sprig-browser";
import type { Me } from "@/generated/graphql";
import type { TrackEventEnum, TrackOptions } from "./tracking-types";
import type { ChannelMetadata } from "@/models";

export class SprigService extends AbstractTrackingService {
  name = "SprigService";
  private envId: string;

  private sprig!: WindowSprig;

  constructor(envId: string) {
    super();
    this.envId = envId;
  }

  public async init(channelMetadata: ChannelMetadata) {
    await super.init(channelMetadata);

    this.sprig = sprig.configure({
      environmentId: this.envId,
    });
  }

  public identifyChannel(): void {
    // Do nothing
  }

  public identifyUser(user: Me) {
    if (!user) return;

    this.sprig("setUserId", user.id);
    this.sprig("setEmail", user.email);
    this.sprig("setAttributes", {
      created_at: user.created_at,
      email: user.email,
      locale: user.locale,
      phone_number: user.phone_number,
      updated_at: user.updated_at,
      username: user.username,
    });
  }

  public resetIdentity() {
    this.sprig("logoutUser");
  }

  public track<T extends TrackEventEnum>(options: TrackOptions<T>) {
    this.sprig(
      "track",
      options.event,
      "metadata" in options ? options.metadata : undefined,
    );
  }
}
